import React from 'react';
import MyActivities from "./my-projects";

const MyActivitiesPage = () => {
    return <MyActivities />;
};

export default MyActivitiesPage;
